module.exports = __webpack_public_path__ + "static/media/company-logo-cv.26bff2b5.png";